import React, { useState, useEffect, useContext } from 'react';
import Grid from '@mui/material/Grid';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
import { SelectModal } from '../SelectModal';
import { MsalContext } from '../../Contexts/MsalContext';

const styles = {
    root: {
        minHeight: '32px',
        backgroundColor: '#e0e0e0',
        borderRadius: '16px',
    },
    text: {
        padding: '0 12px',
    },
    button: {
        padding: 0,
        margin: '4px'
    }
}

interface IFeedbackStatusChipProps {
    filterName: string,
    onSelect: (filterName: string, value: any) => void,
    title: string,
    currentSelection?: any,
    show: boolean;
    removeFilter?: (filter: string, names: string[]) => void;
    filterFlag: string;
    filterNames: string[];
}

export default function FeedbackStatusChip({ filterName, onSelect, title, currentSelection, show, removeFilter, filterFlag, filterNames }: IFeedbackStatusChipProps) {
    const { msalFetch } = useContext(MsalContext);
    const [options, setOptions] = useState<any>([]);

    useEffect(() => {
        getStatuses();
    }, []);

    const handleSelect = (name: any, value: any) => onSelect(name, value);

    const getStatuses = () => {
        msalFetch(`api/Search/GetStatusTypes`)
            .then(response => response.json())
            .then((data: any) =>
                setOptions(data)
            );
    }

    const handleDelete = () => {
        if (removeFilter !== null && removeFilter !== undefined) {
            removeFilter(filterFlag, filterNames);
        }
    }

    return (
        <React.Fragment>
            {show
                ?
                <Grid>
                    <Grid container sx={styles.root} justifyContent="space-between" alignItems="center">
                        <Grid sx={styles.text}>
                            <Typography variant="body1">{title}</Typography>
                        </Grid>
                        <SelectModal title={title} filterName={filterName} mutliSelect={true} currentSelection={currentSelection} onSelect={handleSelect} options={options} searchable={true} />
                        <Grid>
                            {removeFilter !== null && removeFilter !== undefined ?
                                <IconButton title="Remove" aria-label="Remove" onClick={handleDelete} sx={styles.button}><CancelIcon /></IconButton>
                                :
                                <React.Fragment />
                            }
                        </Grid>
                    </Grid>
                </Grid>
                :
                <React.Fragment />
            }
        </React.Fragment>
    );
}